export default __webpack_public_path__ + "static/media/MATIC.68b7c767.png";